export default __webpack_public_path__ + "static/void_hunter-8910b8.svg";